let inject = ['$q','$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];
class MyPaymentsListService {
  constructor ($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.AuthTokenFactory = AuthTokenFactory;
    this.SharedService = SharedService;
    this.SessionService = SessionService;
  }
  
  getPeyments(documentNumber, branch){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + '/recaudos/recaudos/recibos-caja-co?terceroDocumento=' + documentNumber,
        cache : true
      }).then((response) => {
        resolve(response.data);
      }, (reason) => {
        reject(reason);
      });
    });
  }
}

MyPaymentsListService.$inject = inject;

export default MyPaymentsListService;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pay-zone/my-payments/my-payments-list/my-payments-list.service.js
 **/